import React, { memo, useCallback } from 'react';
import styled from 'styles/styled-components';
import { XIcon } from './icons';

interface ImagePreviewProps {
  id: string;
  previewUrl: string;
  onRemove: (id: string) => void;
}

const Thumb = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
`;

const ThumbnailImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  object-fit: cover;
  display: block;
`;

const RemoveBtn = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    background: #f3f4f6;
  }
`;

const ImagePreview = ({ id, previewUrl, onRemove }: ImagePreviewProps) => {
  const handleRemove = useCallback(() => onRemove(id), [id, onRemove]);

  return (
    <Thumb>
      <ThumbnailImage src={previewUrl} alt="" />
      <RemoveBtn type="button" onClick={handleRemove} aria-label="remove image">
        <XIcon />
      </RemoveBtn>
    </Thumb>
  );
};

export default memo(ImagePreview);
